<template>
  <div ref="videoContainer" class="video-container" v-bind:style="videoContainerStyles">
    <video ref="video" playsinline autoplay muted loop>
      <source v-for="videoSrc in sources" :key="videoSrc" :src="videoSrc" />
    </video>
    <div class="overlay" />
  </div>
</template>

<style scoped>

.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

.video-container {
  position: absolute;
  opacity: 0;
  height: 100%;
  width: 100%;
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  -ms-transition: opacity 0.5s ease-in-out;
  -o-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

.video-container video {
  width: 100%;
  height: 100%;
}

</style>

<script>

export default {
  props: {
    sources: Array
  },

  data () {
    return {
      player: null,
      videoContainerStyles: {}
    }
  },

  methods: {
    onWindowResize () {
      const padding = 10
      const width = document.documentElement.clientWidth + padding
      const height = document.documentElement.clientHeight + padding

      if (width / height > 16 / 9) {
        // player.setSize(width, width / 16 * 9)
        this.updateVideoStyles({
          'left': `0px`,
          'width': `${width}px`,
          'height': `${width / 16 * 9}px`
        })
      } else {
        // player.setSize(height / 9 * 16, height)
        this.updateVideoStyles({
          left: `${-(this.$refs.video.clientWidth - document.documentElement.clientWidth) / 2}px`,
          width: `${height / 9 * 16}px`,
          height: `${height}px`
        })
      }
    },

    updateVideoStyles (styles) {
      this.videoContainerStyles = {
        ...this.videoContainerStyles,
        ...styles
      }
    }
  },

  mounted () {
    window.addEventListener('resize', this.onWindowResize)

    this.onWindowResize()

    const videoElement = this.$refs['video']
    videoElement.addEventListener('loadeddata', (e) => {
      this.$nextTick(() => {
        this.onWindowResize()
        this.updateVideoStyles({
          opacity: 1
        })
      })
    })
  },

  beforeDestroy () {
    // clear resize event listener
    window.removeEventListener('resize', this.onWindowResize)
  }
}
</script>
